import { change } from 'redux-form';
import { rewriteAuthInfo } from './auth.actions';

export const STEP_REGISTRATION_ACTION_TYPES = {
  STEP_REGISTRATION_SET_PREVIOUS_FORM_DATA:
    'STEP_REGISTRATION_SET_PREVIOUS_FORM_DATA',
  STEP_REGISTRATION_SET_NULL_INITIAL_OBJECTS:
    'STEP_REGISTRATION_SET_NULL_INITIAL_OBJECTS',
  STEP_REGISTRATION_CHANGE_PROCESSING: 'STEP_REGISTRATION_CHANGE_PROCESSING',
  STEP_REGISTRATION_SKIP: 'STEP_REGISTRATION_SKIP',
  STEP_REGISTRATION_CLEAR_SKIP: 'STEP_REGISTRATION_CLEAR_SKIP',
};

export function getStepFormData({ formsName, url, clearAgeClassification }) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeFormProcessingState(true));

    const response = await axios.get(url);

    dispatch(changeFormProcessingState(false));

    if (!response || response.code !== 'success') {
      return response;
    }

    let { data = {} } = response;

    if (clearAgeClassification && data.ageClassification === undefined) {
      data.ageClassification = [];
      dispatch(change(formsName, `ageClassification`, []));
    }

    dispatch({
      type: STEP_REGISTRATION_ACTION_TYPES.STEP_REGISTRATION_SET_PREVIOUS_FORM_DATA,
      payload: {
        data: data,
        formsName,
        clearAgeClassification,
      },
    });

    return response;
  };
}

export function sendFormData(url, body, method) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeFormProcessingState(true));

    const response = await axios({
      method,
      url: url,
      data: body,
    });

    dispatch(changeFormProcessingState(false));

    if (!response || response.code !== 'success') {
      return response;
    }

    return response;
  };
}

export function checkSkipStep({
  url,
  body,
  method,
  nextRoute,
  generalApiEndpoint,
}) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeFormProcessingState(true));

    const response = await axios({
      method,
      url,
      data: body,
    });

    dispatch(changeFormProcessingState(false));

    if (!response || response.code !== 'success') {
      return response;
    }

    const { data } = response;

    dispatch({
      type: STEP_REGISTRATION_ACTION_TYPES.STEP_REGISTRATION_SKIP,
      payload: {
        status: data,
        nextRoute,
        generalApiEndpoint,
      },
    });

    return response;
  };
}

export function sendStepForm({
  body,
  url,
  method,
  formStateFieldName,
  formsName,
}) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();
    const validMethods = ['post', 'get', 'put', 'delete'];

    dispatch(changeFormProcessingState(true));
    let response;

    if (method && validMethods.includes(method)) {
      response = await axios[method](url, body);
    } else {
      response = await axios.put(url, body);
    }
    dispatch(changeFormProcessingState(false));

    if (!response || response.code !== 'success') {
      return response;
    }

    const { stepRegistration = {} } = getState();

    const { data = {} } = response || {};

    if (
      body.participatedClinicalTrialsPreviously !== undefined &&
      body.participatedClinicalTrialsPreviously === false
    ) {
      dispatch({
        type: STEP_REGISTRATION_ACTION_TYPES.STEP_REGISTRATION_SET_PREVIOUS_FORM_DATA,
        payload: {
          data: {
            ...stepRegistration[formsName],
            [formStateFieldName]: { ...data },
            financialDisclosure: {},
            regulatoryOversight: {},
          },
          formsName,
        },
      });
    } else {
      dispatch({
        type: STEP_REGISTRATION_ACTION_TYPES.STEP_REGISTRATION_SET_PREVIOUS_FORM_DATA,
        payload: {
          data: {
            ...stepRegistration[formsName],
            [formStateFieldName]: { ...data },
          },
          formsName,
        },
      });
    }

    return response;
  };
}

export function generalSubmitForms({ url, shouldRewriteAuthInfo = false }) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeFormProcessingState(true));

    const response = await axios.post(url);

    dispatch(changeFormProcessingState(false));

    if (!response || response.code !== 'success') {
      return response;
    }

    const { data = {} } = response || {};

    if (shouldRewriteAuthInfo) {
      dispatch(rewriteAuthInfo(data));
    }

    return response;
  };
}

export function setNullInitialObjects(
  config = { excludeObjectNames: [], formsName: '' },
) {
  return {
    type: STEP_REGISTRATION_ACTION_TYPES.STEP_REGISTRATION_SET_NULL_INITIAL_OBJECTS,
    payload: config,
  };
}

export function changeFormProcessingState(newState) {
  return {
    type: STEP_REGISTRATION_ACTION_TYPES.STEP_REGISTRATION_CHANGE_PROCESSING,
    payload: newState,
  };
}

export function clearSkipStep() {
  return {
    type: STEP_REGISTRATION_ACTION_TYPES.STEP_REGISTRATION_CLEAR_SKIP,
    payload: {
      status: false,
      nextRoute: '',
      generalApiEndpoint: '',
    },
  };
}
